import { Component, Input, OnInit } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { DialogUtils } from "@app/DialogUtils";
import { MessageUtils } from "@app/MessageUtils";
import { User } from "@app/models/User";
import { AuthService } from "@app/services/auth/auth.service";
import { UserService } from "@app/services/user/user.service";
import { AppService, SessionStorageService } from "@mova/components/core";


@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit {
  // private showBaja: Boolean = false;
  private isLogged: Boolean = true;

  constructor(
    private _appService: AppService,
    private _userService: UserService,
    private _authService: AuthService,
    private router: Router,
    private _sessionStorageService: SessionStorageService
  ) {}

  ngOnInit(): void {
  }

  /**
   * Comprueba si debe mostrar la opción de dar de baja.
   * @returns true en caso de mostrarlo.
   * @return false en caso de no mostrarlo.
   */
  showBaja() {
    if (this._authService.isLogged() && this.router.url === "/datos-usuario") {
      return true
    } else {
      return false
    }
  }



  /**
   * Abre un dialog para darse de baja.
   */
  openDialogBajaUser() {
    let data = DialogUtils.getDialogBajaUser();

    let self = this;

    //Acción después de elegir una opción en el dialog.
    function successCallback(result: any) {
      if (result.accept) {
        self.darDeBaja();

      }
    }

    data["successCallback"] = successCallback;
    this._appService.openDialog(data);
  }

  /**
   * Da de baja a un usuario.
   */
  darDeBaja() {
    if (this._authService.isLogged) {

      let user:User = this._sessionStorageService.getItem(MessageUtils.DATA_USER);
      this._userService.bajaUser(user.idUser).subscribe(
        (data) => {
          this._sessionStorageService.setItem(MessageUtils.CONFIRM_BAJA, true);
          this.router.navigate(["login-view"]);
        },
        (error) => {

          this.openDialogErrorForm();
        }
      );
    }

  }

  /**
   * Abre un dialog de error del formulario.
   * @return true Cuando se cierra el modal.
   */
  public openDialogErrorForm() {
    let dialogFormError = DialogUtils.getDialogErrorForm();

    let self = this;

    function successCallback(result: any) {
      self.router.navigate(["login-view"]);
    }

    dialogFormError["successCallback"] = successCallback;
    this._appService.openDialog(dialogFormError);
  }
}
